import Observer from "./Observer.js";
import Subject from "./Subject.js";
import DefineProperty from "./DefineProperty.js";

export default class Intercept{
    constructor(){
        this._dom = null;
        this._obj = null;
        this._key = "";
        this._subject = null;        
    }

    init(dom, obj, key, type,firstClass = '',lastClass = ''){
        
        this._obj = obj;
        this._key = key;
        this._subject = new Subject();
        if(dom){
            this._dom = dom;        
            let _observer = new Observer(this._dom, type,firstClass,lastClass);            
            this._subject.register(_observer);
        }

        new DefineProperty(this._obj).listenerField(this._key, (value)=>{
            this._subject.update(value);
        });
    }

    addObserver(dom,type,firstClass = '',lastClass = ''){
        let _observer = new Observer(dom, type,firstClass,lastClass);        
        this._subject.register(_observer);
        
    }
}